import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Box, CircularProgress } from '@mui/material';
import { P } from '../components';

const AuthCallbackPage = () => {
  const navigate = useNavigate();
  const { user, userType, loading } = useAuth();

  useEffect(() => {
    if (!loading && user) {
      // Redirect based on user type
      if (userType === 'guardian') {
        navigate('/guardian', { replace: true });
      } else if (userType === 'child') {
        navigate('/play', { replace: true });
      } else {
        navigate('/', { replace: true });
      }
    } else if (!loading && !user) {
      // If no user after loading, redirect to login
      navigate('/login', { replace: true });
    }
  }, [user, userType, loading, navigate]);

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      minHeight="100vh"
      gap={2}
    >
      <CircularProgress size={48} />
      <P color="text.secondary">Completing sign in...</P>
    </Box>
  );
};

export default AuthCallbackPage;
